<template>
  <div class="search-input-component">
    <ym-button class="cancel-btn"
               type="text"
               size="mini"
               @click="handleCancel"
    >
      <ym-icon name="back" />
    </ym-button>
    <form class="search-input-container"
          @submit.prevent="handleSearch"
    >
      <ym-icon class="search-input-icon icon-search"
                name="search"
      />
      <input class="search-input"
             v-model="key"
             ref="input"
             v-focus.lazy="true"
             type="search"
             title="search"
             :placeholder="placeholder"
             @blur="handleBlur"
             @keyup.enter="handleSearch"
      >
      <ym-icon v-if="key !== ''"
                class="search-input-icon icon-close"
                name="round-close-fill"
                @click.native="handleClose"
      />
    </form>
    <ym-button class="search-btn"
               :class="[
                 { 'is-active': key !== '' },
               ]"
               type="text"
               size="extra-small"
               @click="handleSearch"
    >搜索
    </ym-button>
  </div>
</template>

<script>
  import { Button } from '@ymba/ym-ui';

  export default {
    name: 'SearchInput',
    components: {
      'ym-button': Button,
    },
    data() {
      return {
        key: '',
      };
    },
    props: {
      value: {
        type: String,
      },
      placeholder: {
        type: String,
      },
    },
    watch: {
      value(val) {
        this.key = val;
      },
    },
    methods: {
      handleBlur() {
        this.$nextTick(() => {
          const { key } = this;
          if (key === '') return;
          this.handleSearch();
        });
      },
      handleSearch() {
        const { key, placeholder } = this;
        if (key === '') {
          this.key = placeholder;
        }
        const $input = this.$refs.input;
        if ($input != null) {
          $input.blur();
        }
        this.$emit('search', this.key);
      },
      handleClose() {
        this.key = '';
        this.$refs.input.focus();
      },
      handleCancel() {
        this.$emit('cancel');
      },
    },
    created() {
      this.key = this.value;
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .search-input-component {
    flex: 1;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .search-input-container {
    flex: 1;
    overflow: hidden;
    display: flex;
    align-items: center;
    padding: 0 @search-padding-size;
    height: @search-bar-height;
    border-radius: (@search-bar-height / 2);
    background-color: @color-gray-lighter;
  }

  .search-input-icon {
    color: @color-gray-light;
  }

  .icon-search {
    font-size: 34px;
  }

  .icon-close {
    font-size: 28px;
  }

  .search-input {
    padding: 0 @size-extra-small;
    outline: none;
    flex: 1;
    font-size: @font-size-base;
    line-height: 1.2;
    color: @color-text-light;
  }

  .cancel-btn {
    padding: 0 @size-small 0 @size-base;
    font-size: @size-base;
    color: @color-text-base;
  }

  .search-btn {
    font-size: @font-size-medium;
    color: @color-text-lighter;
    padding: 0 @size-base 0 @size-small;
    &.is-active {
      color: @color-text-primary;
    }
  }
</style>
